<template>
  <div>
    <CCard v-if="!mediaKit.welcome_code">
      <CCardBody>
        <CRow>
          <CCol>
            <translate>
              You need to save the event before you can access the Media Kit
            </translate>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <template v-else>
      <CRow>
        <CCol>
          <CCard>
            <CCardBody class="px-3 py-0">
              <div class="grid-stripped">
                <CRow class="py-4 align-items-center justify-content-between">
                  <CCol>
                    <h6 class="mb-1" v-translate>Welcome code</h6>
                    <span v-translate>9-digit alphanumeric code to access the event</span>
                  </CCol>
                  <CCol col="auto">
                    <span style="font-size: 16px;font-weight: 700;">{{ mediaKit.welcome_code }}</span>
                    <CButton size="sm" color="primary" variant="outline" class="ml-5 btn-circle"
                             @click="copyURL(mediaKit.welcome_code, $gettext('Access Code'))">
                      <CIcon name="cipCopy"/>
                    </CButton>
                  </CCol>
                </CRow>
                <CRow class="py-4 align-items-center justify-content-between">
                  <CCol>
                    <h6 class="mb-1" v-translate>Direct event link</h6>
                    <span>{{ mediaKit.direct_link }}</span>
                    <CLink class="ml-2"
                           @click="copyURL(mediaKit.direct_link, $gettext('Direct event link'))">
                      <CIcon name="cipCopy" size="custom-size" :height="20"/>
                    </CLink>
                  </CCol>
                </CRow>
                <CRow class="py-4 align-items-center justify-content-between">
                  <CCol>
                    <h6 class="mb-1" v-translate>QR code</h6>
                    <span>{{ mediaKit.qr_code }}</span>
                    <CLink class="ml-2"
                           @click="copyURL(mediaKit.qr_code, $gettext('Qr Code'))">
                      <CIcon name="cipCopy" size="custom-size" :height="20"/>
                    </CLink>
                  </CCol>
                  <CCol col="auto">
                    <!--<CButton size="sm" color="primary" variant="outline" class="btn-circle"
                             @click="showQrCodeModal = true">
                      <CIcon name="cipPencil"/>
                    </CButton>-->
                    <div class="d-flex align-items-center">
                    <qrcode-vue
                        :value="mediaKit.qr_code"
                        :size="60"
                    />
                    <CButton size="sm" color="primary" variant="outline" class="ml-3 btn-circle"
                             @click="showQrCodeModal = true">
                      <CIcon name="cipDownload"/>
                    </CButton>
                    </div>
                  </CCol>
                </CRow>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CRow>
        <CCol col="12">
          <CCard>
            <CCardHeader>
              <h5 class="my-2" v-translate>Campaign text</h5>
            </CCardHeader>
            <CCardBody class="p-0">
              <CTabs :active-tab="0" class="tabs--light">
                <CTab title="English">
                  <CTextarea :value="mediaKit.social_text.en"/>
                  <CButton size="sm" color="primary" variant="outline" class="btn-copy btn-circle"
                           @click="copyURL(mediaKit.social_text.en, $gettext('Text'))">
                    <CIcon name="cipCopy"/>
                  </CButton>
                </CTab>
                <CTab title="Italian">
                  <CTextarea :value="mediaKit.social_text.it"/>
                  <CButton size="sm" color="primary" variant="outline" class="btn-copy btn-circle"
                           @click="copyURL(mediaKit.social_text.it, $gettext('Text'))">
                    <CIcon name="cipCopy"/>
                  </CButton>
                </CTab>
                <CTab title="French">
                  <CTextarea :value="mediaKit.social_text.fr"/>
                  <CButton size="sm" color="primary" variant="outline" class="btn-copy btn-circle"
                           @click="copyURL(mediaKit.social_text.fr, $gettext('Text'))">
                    <CIcon name="cipCopy"/>
                  </CButton>
                </CTab>
                <CTab title="German">
                  <CTextarea :value="mediaKit.social_text.de"/>
                  <CButton size="sm" color="primary" variant="outline" class="btn-copy btn-circle"
                           @click="copyURL(mediaKit.social_text.de, $gettext('Text'))">
                    <CIcon name="cipCopy"/>
                  </CButton>
                </CTab>
              </CTabs>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CModal :title="$pgettext('mediakit.qrcode','Generate QR Code')" :show.sync="showQrCodeModal" centered>
        <QRCodeGenerator ref="qrCodeGenerator" :value="mediaKit.qr_code"
                         :file-name="`QRCode-${mediaKit.welcome_code}`"/>
        <template #footer>
          <CRow class="w-100">
            <CCol>
              <CButton @click="showQrCodeModal = false" color="secondary" block size="sm" v-translate>Close</CButton>
            </CCol>
            <CCol>
              <CButton @click="download()" size="sm" block color="primary" v-translate translate-context="qrcode">
                Download
              </CButton>
            </CCol>
          </CRow>
        </template>
      </CModal>
    </template>
  </div>
</template>

<script>
import QRCodeGenerator from "@/domain/core/components/qrcode/QRCodeGenerator.vue";
import QrcodeVue from "qrcode.vue";

export default {
  name: 'MediaKit',
  components: {QrcodeVue, QRCodeGenerator},
  props: {
    mediaKit: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showQrCodeModal: false
    }
  },
  methods: {
    download() {
      this.$refs.qrCodeGenerator.download()
    },
    copyURL(url, description) {
      navigator.clipboard.writeText(url);
      this.notifyMessage({text: this.$gettext(description + ' copied!'), messageType: 'success'})
    }
  }
}
</script>
